import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, trim } from 'lodash';
import { Avatar } from '@src/components/Avatar';
import { Image } from '@src/components/Image';
import { TextField } from '@src/components/TextField';
import { getRecruiter } from '@src/redux/selectors/recruiter';
import { getCompany } from '@src/redux/selectors/company';
import { RootState } from '@src/redux/interfaces/redux.interface';
import { MESSAGE_MIN_LENGTH } from '../../Footer';
import './styles.scss';

function Message({ defaultMessage = '', onMessageChange, recruiter, company }) {
  const [message, setMessage] = useState(defaultMessage);
  const handleMessageChange = value => {
    setMessage(value);
    onMessageChange(value);
  };

  const recruiterName = get(recruiter, 'firstName');
  const recruiterNameInitials = get(recruiter, 'nameInitials');
  const recruiterAvatar = get(recruiter, 'avatarUrl');
  const avatarColor = get(recruiter, 'avatarColor');
  const companyName = get(company, 'profile.name');
  const companyLogo = get(company, 'profile.logo.fullUrl');

  return (
    <div className="verify-talent-message">
      <div className="verify-talent-message__container">
        <div className="verify-talent-message__avatar">
          <Avatar
            avatarColor={avatarColor}
            className="verify-talent-message__avatar-image"
            initials={recruiterNameInitials}
            source={recruiterAvatar}
          />
          <Image className="verify-talent-message__company-image" src={companyLogo} />
        </div>
        <div className="verify-talent-message__wrapper">
          <h3 className="verify-talent-message__user">
            {recruiterName} - {companyName}
          </h3>
          <TextField
            containerClassName="verify-talent-message__input-container"
            defaultValue={message}
            fullWidth
            inputClassName="verify-talent-message__input"
            multiline
            onChange={handleMessageChange}
            placeholder={
              'Introduce your company as an employer and the position you are looking to fill. Leave a good first impression by being concise and compelling.'
            }
            wrapperClassName="verify-talent-message__input-wrapper"
          />
        </div>
      </div>

      <div className="verify-talent-message__limit">
        <p className="verify-talent-message__text-limit">
          {`Minimum ${MESSAGE_MIN_LENGTH} characters. ${trim(message).length}/${MESSAGE_MIN_LENGTH}`}
        </p>
      </div>
    </div>
  );
}

Message.propTypes = {
  company: PropTypes.object.isRequired,
  defaultMessage: PropTypes.string,
  onMessageChange: PropTypes.func.isRequired,
  recruiter: PropTypes.object.isRequired,
};

export default connect(
  (state: RootState) => ({
    company: getCompany(state),
    recruiter: getRecruiter(state),
  }),
  null,
)(Message);
